<template>
  <!-- 页面底部组件 -->
  <div class="footer">
    <div class="contactUs">
      <div class="footerTitle">联系我们</div>
      <div class="contactUsMsg">
        <!-- <p>广东优壹科技有限公司</p>
        <p>通信地址： 广州高新技术产业开发区揽月路8号自编一栋238、239、240、241、242、243房间间</p>
        <p>固定电话：020-32022099 邮编：510670</p>
        <p>联系邮箱：service@uxuepai.net</p>-->
        <p>U学商情咨询：18926288521（微信同号）</p>
        <p>公司名称：广东优壹科技有限公司</p>
        <p>地址：广州高新技术产业开发区揽月路8号自编一栋238、239、240、241、242、243房间</p>
      </div>
    </div>
    <div class="compayEwm">
      <ul>
        <li>
          <div class="ewmImg">
            <img src="../footer/img/ewm.png">
          </div>
          <div class="con">U学商情移动端</div>
        </li>
        <li>
          <div class="ewmImg">
            <img src="../footer/img/ewm1.png">
          </div>
          <div class="con">U学商情客服</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "page-footer",
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  padding: 0 40px;
  height: 160px;
  background: #646464;
}
.footer .contactUs {
  float: left;
  text-align: left;
  font-size: 14px;
  color: #fff;
  padding-top: 30px;
  line-height: 20px;
}
.footer .compayEwm {
  float: right;
  font-size: 14px;
  color: #fff;
  padding-top: 22px;
  line-height: 20px;
}
.footer .compayEwm li {
  float: left;
  width: 100px;
  margin-left: 5px;
  text-align: center;
  
}
.footer .compayEwm .ewmImg img {
  width: 77px;
  height: 77px;
}
.footer .compayEwm .con {
  padding-top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue